// extracted by mini-css-extract-plugin
module.exports = {"modalContentWrapper":"AttributeModalWarning_modalContentWrapper__1ayD6","cardItemShield":"AttributeModalWarning_cardItemShield__3cNfT"};